jQuery(function($){
  $('.sponsorship__popin-btn').magnificPopup({
    type: 'inline',
    showCloseBtn: false
  });
  $('.sponsorship-popin__close-btn').on( "click", function() {
    $.magnificPopup.close();
  });
});
